import styled from 'styled-components';
import { COLORS } from '../../styles/variables';
import { device } from '../../styles/devices';

export const Container = styled.div`
  position: relative;
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 28px;
  @media ${device.tablet} {
    flex-direction: row;
    justify-content: center;
    gap: 28px;
    flex-wrap: wrap;
    align-items: unset;
  }
  @media ${device.laptop} {
    gap: 44px;
  }
`;

export const ViewMoreButton = styled.button<{ shouldRotate: boolean }>`
  font-family: 'Audi Type';
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  padding: 1px 0;
  gap: 8px;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.002px;
  color: ${COLORS.grey60};
  cursor: pointer;
  svg {
    transition: transform 0.5s;
    transform: rotateZ(${(props) => (props.shouldRotate ? '180deg' : '0deg')});
  }
`;

export const HeaderContainer = styled.div`
  padding-bottom: 32px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  @media ${device.laptop} {
    align-items: center;
    padding-bottom: 24px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  @media (min-width: 1100px) {
    flex-direction: row;
    gap: 24px;
    align-items: baseline;
  }
`;

export const ViewMoreDesktopWrapper = styled.div`
  padding-top: 8px;
  align-self: flex-end;
  @media ${device.laptop} {
    display: flex;
    padding-top: 0;
  }
`;

export const ViewMoreFooter = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
  padding-top: 32px;
`;

export const ViewMoreMobileWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
  @media ${device.laptop} {
    display: none;
  }
`;

export const CardWrapper = styled.div`
  width: 100%;
  max-width: 356px;
  background-color: ${COLORS.white};
  padding: 16px 12px;
  min-height: 255px;
  display: flex;
  flex-direction: column;
`;

export const CardTitleWrapper = styled.div`
  display: flex;
  gap: 12px;
  padding-bottom: 8px;
`;

export const CardInfoWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const CashCTA = styled.button`
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
  padding: 1px 0;
  gap: 3px;
  align-self: flex-end;
  color: ${COLORS.black};
  font-family: 'Audi Type';
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.002px;
  cursor: pointer;
`;

export const Title = styled.h3<{ isBold?: boolean }>`
  margin: 0;
  font-family: 'Audi Type';
  letter-spacing: 0.001px;
  font-size: 18px;
  line-height: 28px;
  font-weight: ${(props) => (props.isBold ? '700' : '400')};
  color: ${COLORS.grey80};
`;
